/* eslint-disable no-param-reassign */

import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Grid,
  Pagination,
} from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';
import LoanList from 'src/components/loans/LoanList';
import { filterLoans } from '../store/actions/loans.action';

function GroupLoans() {
  const [filterPayload, setFilterPayload] = useState({ loanTypeId: '1003' });
  const [page, setPage] = useState(1);

  const pageSize = 15;

  const dispatch = useDispatch();
  const loanState = useSelector((state) => state.loansReducer);
  const { groupLoans } = loanState;
  console.log(loanState);

  useEffect(() => {
    dispatch(filterLoans(filterPayload, { page, pageSize }));
  }, [dispatch, filterPayload, page]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    dispatch(filterLoans(filterPayload, { page: newPage, pageSize }));
  };

  return (
    <>
      <Helmet>
        <title>Group Loans | Rewot dashboard</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
        }}
      >
        <Container maxWidth={false}>

          {/* <Grid container spacing={1}>

            <Grid item xs={9}>
              <Card>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 1 }}>FILTERS</Typography>

                  <Stack direction="row" spacing={3} sx={{ height: 56 }}>
                    <FormControl sx={{ minWidth: 200 }}>
                      <InputLabel id="order-status-label">Order Status</InputLabel>

                      {/* <Select
                        labelId="order-status-label"
                        id="order-status-select"
                        value={selectedStatus}
                        onChange={(event) => handleStatusChange(event.target.value)}
                        label="Order Status"
                      >
                        <MenuItem value="">
                          <em>All</em>
                        </MenuItem>

                        {orderStatuses.map((name) => (
                          <MenuItem
                            key={name}
                            value={name}
                          >
                            {name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl sx={{ minWidth: 200 }}>
                      <InputLabel id="payment_method-label">Payment Method</InputLabel>

                      {/* <Select
                        labelId="payment_method-label"
                        id="payment_method-select"
                        value={selectedPaymentMethod}
                        onChange={(event) => handlePaymentChange(event.target.value)}
                        label="Payment method"
                      >
                        <MenuItem value="">
                          <em>All</em>
                        </MenuItem>

                        {paymentMethods.map((name) => (
                          <MenuItem
                            key={name}
                            value={name}
                          >
                            {name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    {/* <FormControl sx={{ minWidth: 200 }} disabled={isLipaDisabled}>
                      <InputLabel id="lipa-status-label">Payment Status</InputLabel>
                      <Select
                        labelId="lipa-status-label"
                        id="lipa-status-select"
                        value={selectedLipaStatus}
                        onChange={(event) => handleLipaStatus(event.target.value)}
                        label="Mpesa Status"
                      >
                        <MenuItem value="">
                          <em>All</em>
                        </MenuItem>

                        {paymentStatuses.map((name) => (
                          <MenuItem
                            key={name}
                            value={name}
                          >
                            {name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={3}>

              <Grid
                container
                spacing={1}
                direction="row"
                justifyContent="flex-end"
                sx={{ mt: 4 }}
              >

                <Stack direction="row" spacing={3} sx={{ height: 56 }}>
                { orders && (
                  <CSVLink
                    data={orders}
                    headers={headers}
                    filename="Rewot-Orders.csv"
                    target="_blank"
                  >
                    <Button variant="contained" sx={{ marginRight: 0, color: 'white' }} startIcon={<ArrowUpward />}>
                      EXPORT
                    </Button>

                  </CSVLink>
                  )}
                </Stack>

              </Grid>
            </Grid>
          </Grid> */}

          <Box sx={{ pt: 3 }}>
            {groupLoans && (
            <LoanList loans={groupLoans.data} title="Group Loans" />
            )}
          </Box>

          {
            groupLoans && (
            <Grid
              container
              spacing={1}
              direction="row"
              justifyContent="flex-end"
              sx={{ mt: 4 }}
            >
              <Pagination
                count={groupLoans.pagination.totalPages}
                color="primary"
                defaultPage={1}
                showFirstButton
                showLastButton
                onChange={handlePageChange}
              />

            </Grid>
            )
        }

        </Container>
      </Box>
    </>
  );
}

export default GroupLoans;
